/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Managers/ExceptionManager',[
    'gameconfig', 'Managers/TelemetryManager'],
    function (GameConfig, TelemetryManager) {
    "use strict"

    var ExceptionManager = {
        throttleByMessageNextLogInstant: new Map(),
        throttleByNameNextLogInstant: new Map(),
        throttleByStackNextLogInstant: new Map(),
        throttleCooldownMilliseconds: 60 * 1000,
        getErrorCategory: function (error) {
            var category = {
                matchValue: "",
                throttleMap: null
            };

            if (typeof error.message !== "undefined" && error.message !== null && error.message !== "") {
                category.matchValue = error.message;
                category.throttleMap = this.throttleByMessageNextLogInstant;
            } else if (typeof error.name !== "undefined" && error.name !== null && error.name !== "") {
                category.matchValue = error.name;
                category.throttleMap = this.throttleByNameNextLogInstant;
            } else if (typeof error.stack !== "undefined") {
                var stackString = String(error.stack);
                if (stackString !== null && stackString !== "") {
                    category.matchValue = stackString;
                    category.throttleMap = this.throttleByStackNextLogInstant;
                }
            }

            return category;
        },
        isErrorThrottled: function (category) {
            if (category.throttleMap !== null && category.throttleMap.has(category.matchValue)) {
                return category.throttleMap.get(category.matchValue) >= Date.now();
            }

            return false;
        },
        onErrorHandler: function (message, source, lineno, colno, error) {
            if (error) {
                var evaluation = this.getErrorCategory(error);
                if (this.isErrorThrottled(evaluation)) {
                    return true;
                } else if (evaluation.throttleMap !== null) {
                    evaluation.throttleMap.set(evaluation.matchValue, Date.now() + this.throttleCooldownMilliseconds);
                    TelemetryManager.appException(error || {});

                    return false;
                }
            } else {
                if(message)
                    TelemetryManager.appException(message || {});
                else
                    TelemetryManager.appException("undefined" || {});
            }
        },
        initialize: function () {
            window.onerror = this.onErrorHandler.bind(this);
        }
    }

    return ExceptionManager;
});
